import React, { forwardRef, useState, useEffect } from "react";
import apiService from "apiService";
import Select2 from "react-select";
import Alert, {showLoading, toast} from "view/component/Alert";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import "react-datepicker/dist/react-datepicker.css";
import { confirmedAlert } from "../../component/Alert";
import moment from "moment";
import Table from "../../component/Table1";

const History = (props) => {
  const [refPregnantVisit, setRefPregnantVisit] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [param, setParam] = useState({
    visit_id: props.patient.id,
    hpht: '-',
    number_of_visit: 1,
    age_of_pregnant: 1,
    trimester: 1,
    visit_type: "k1",
    visit_types: {
      value: 'k1',
      label: 'K1',
    },
    complaint: "",
    fundus_height: 0,
    fundus_height_explanation: "",
    leopold2: 1,
    leopold2s: {
      value: 1,
      label: "Punggung kanan",
    },
    fetal_position: "Kepala",
    fetal_positions: {
      value: "Kepala",
      label: "Kepala",
    },
    fetal_heart_beat: true,
    fetal_pulse: 0,
    edema: false,
    patella: false,
    head_presentation: 0,
    tbj: 0,
    fe_count: 0,
    fetal_count: 1,
    tt_yes_no: false,
    tt_immunization: null,
    fe_yes_no: false,
    fe: null,
    iodized_oil: false,
    risk_factor: "",
    complication: "",
    found_by: "nakes",
    leopold: '',
    leopold_obj: '',
    pregnant_id: ''
  });
  const [pregnantData, setPregnantData] = useState(null)
  const [waText, setWaText] = useState('Halo Ayah {{nama_suami}}, Sekarang Bunda {{nama_istri}} telah memasuki kehamilan trimester ke {{tm}} ({{start_week}} - {{end_week}} minggu), Saatnya lakukan pemeriksaan {{jenis_kunjungan}}, yaitu pemeriksaan {{treatment}}. Yuk sambut kehadiran buah hati dengan selalu memeriksakan kehamilan ke Puskesmas {{puskesmas}}. kunjungi http://bit.ly/sigapmanismanja_jadwal untuk jadwal ANC lengkap Bunda')
  const [preview, setPreview] = useState('')
  const [waDueDate, setWaDueDate] = useState('')
  const [nextRefPregnant, setNextRefPregnant] = useState(null)
  const [noWa, setNoWa] = useState('')

  const getPregnant = async () => {
    let res = await apiService.get(
      "/registration/pregnant_visit/read/" + props.patient.patient_id
    );
    let age_of_pregnant = 1, trimester = 1, hpht = '', newParam = {};
    if (res && res.code === 200) {
      if (!res.data.pregnant) {
        Alert("warning", "Riwayat kehamilan tidak ditemukan");
      }
      else {
        var a = moment();
        var b = moment(res.data.pregnant.hpht).isAfter() ? moment() : moment(res.data.pregnant.hpht);
        age_of_pregnant = Math.ceil(a.diff(b, 'days') / 7);
        trimester = Math.ceil(a.diff(b, 'days') / 84);
      }

      hpht = res.data.pregnant ? moment(res.data.pregnant.hpht).format("DD-MM-YYYY") : '-'
      setParam({
        ...param,
        hpht,
        pregnant_id: res.data.pregnant ? res.data.pregnant.id : 0,
        number_of_visit: res.data.history.length + 1,
        trimester: trimester,
        age_of_pregnant: age_of_pregnant
      })
      setPregnantData(res.data.pregnant)
      setRefPregnantVisit(res.data.history);
    }

    showLoading("Mencari Data");
    const r = await apiService.get('registration/pregnant/ref_pregnant_visit')
    toast({ status: "success", text: "Data Ditemukan" });
    if (r && r.code === 200) {
      let visit_type = param.visit_type
      let visit_types = param.visit_types
      for (let [i, v] of r.data.entries()) {
        if (age_of_pregnant === 0 || (age_of_pregnant >= v.start_week && age_of_pregnant <= v.end_week)) {
          visit_type = v.k.toLowerCase()
          visit_types = {
            value: v.k.toLowerCase(),
            label: v.k.toUpperCase(),
          }

          if (i < r.data.length - 1) {
            const next = r.data[i + 1]
            setNextRefPregnant(next)
            const sp = hpht.split('-'), hpht_ = `${sp[2]}-${sp[1]}-${sp[0]}`
            setWaDueDate(moment(hpht_).add(v.end_week, 'weeks').format("YYYY-MM-DD"))
          }

          setParam({
            ...param,
            pregnant_id: res.data.pregnant ? res.data.pregnant.id : 0,
            visit_type,
            visit_types,
          })

          break
        }
      }
    }
  };

  useEffect(() => {
    getPregnant();
  }, [modalShow]);

  useEffect(() => {
    if (pregnantData && nextRefPregnant) {
      setPreview(
          waText
              .replace('{{nama_suami}}', pregnantData.husband_name)
              .replace('{{nama_istri}}', `${props.patient.patients.name}${props.patient.patients.last_name ? ` ${props.patient.patients.last_name}` : ''}`)
              .replace('{{tm}}', nextRefPregnant.tm.replace('TM ', ''))
              .replace('{{start_week}}', nextRefPregnant.start_week)
              .replace('{{end_week}}', nextRefPregnant.end_week)
              .replace('{{jenis_kunjungan}}', nextRefPregnant.k)
              .replace('{{treatment}}', nextRefPregnant.treatment.toUpperCase())
              .replace('{{puskesmas}}', JSON.parse(localStorage.getItem('puskesmasProfile')).name)
      )
    }
  }, [pregnantData, nextRefPregnant, waText])

  const postParam = async () => {
    let res = await apiService.post(
      "/registration/pregnant_visit/create",
      {...param, wa_due_date: waDueDate, preview, next_k: nextRefPregnant?.k ?? ''}
    );
    if (res.code === 200) {
      await apiService.post(`fhir/satu_sehat/observation_bundle/${param.visit_id}`, {
        types: ['tinggi-fundus', 'djj']
      });
      Alert("success", "data disimpan");
      setModalShow(false);
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getPregnant();
  };

  const createButtonDelete = (datad) => {
    return (
      <button
        onClick={(e) => {
          confirmedAlert(
            "Konfirmasi",
            "Apakah anda akan menghapus data riwayat kehamilan?",
            function (confirmed) {
              if (confirmed) {
                delHistory(datad);
              }
            }
          );
        }}
        className='btn btn-sm btn-danger'>
        <span className='btn-inner--icon'>
          <i className='fas fa-minus'></i>
        </span>
      </button>
    );
  };

  const createButton = (datad) => {
    return (
      <button
        onClick={(e) => { }}
        className='btn btn-sm btn-secondary text-primary'>
        <span className='btn-inner--icon'>
          <i className='fas fa-print'></i>
        </span>
      </button>
    );
  };

  const delHistory = async (dataid) => {
    let res = await apiService.delete(
      "/registration/pregnant_visit/delete/" + dataid
    );
    if (res.code === 200) {
      Alert("success", "data dihapus");
    } else {
      Alert("error", "gagal menghapus data");
    }
    getPregnant();
  };

  return (
    <>
      <div className='card mt-4'>
        <div className='card-header bg-success text-white'>
          Riwayat Pemeriksaan Kehamilan
        </div>
        <div className='card-header'>
          <Table
            className='table table-responsive'
            headers={[
              "No",
              "Menu",
              "Tanggal",
              "Usia Kehamilan",
              "Bidan",
              "Pemberian FE",
              "Tinggi Fundus",
              "Letak Janin",
              "Denyut Jantung Bayi",
              "Jumlah Denyut Jantung Bayi",
              "Edema",
              "Patella",
              "Diagnosa",
            ]}
            data={refPregnantVisit}
            columnMapper={(datas, key) => [
              datas.log ? (
                <span className='btn btn-sm btn-block btn-outline-danger'>
                  DELETED
                </span>
              ) : (
                <>
                  {createButton(datas.id)}
                  {createButtonDelete(datas.id)}
                </>
              ),
              moment(datas?.visit?.created_at).format("DD-MM-YYYY"),
              datas?.age_of_pregnant + " Minggu",
              datas?.doctor?.name,
              datas?.fe_count + ' tablet', ,
              <>
                <div>{datas.fundus_height} cm</div>
                <div>{datas.fundus_height_explanation}</div>
              </>,
              <>
                <div>{datas.fetal_position}</div>
                <div>{datas.head_presentation ? ('TBJ: ' + datas.tbj + ' gram') : ''}</div>
              </>,
              datas.fetal_heart_beat ? "Ada" : "Tidak Ada",
              datas.fetal_pulse,
              datas.edema,
              datas.pattela ? "Positif" : "Negatif",
              datas.visit?.diagnoses?.map((data, i) => (
                <div key={i}>{data.icd_code + "-" + data.icd_name}</div>
              )),
            ]}
            issearch={false}
            pagination={false}
          />
        </div>
        <div className='card-footer'>
          <div
            className='btn btn-outline-success'
            onClick={() => setModalShow(true)}>
            Tambah Data Pemeriksaan
          </div>
        </div>
      </div>
      <Modal
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
        scrollable
        backdrop='static'>
        <ModalHeader>
          <ModalTitle id='contained-modal-title-vcenter'>
            Tambah Pemeriksaan Kehamilan
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className='align-items-center'>
            <div className='list-group mb-4'>
              <div className='list-group-item mt-0 mb-0 text-white bg-gray'>
                <div className='h4 text-white'>PEMERIKSAAN IBU HAMIL</div>
              </div>
              <div className='list-group-item'>
                <div className='row'>
                  <div className='col-md-3'>
                    <div className='form-group'>
                      <label className='form-control-label'>Kunjungan ke</label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.number_of_visit}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              number_of_visit: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div className='form-group'>
                      <label className='form-control-label'>HPHT</label>
                      <div className='input-group'>
                        <input
                          type='text'
                          value={param.hpht}
                          disabled
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Usia Kehamilan
                      </label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.age_of_pregnant}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              age_of_pregnant: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                        <div className='input-group-append'>
                          <span className='input-group-text text-default bg-secondary'>
                            Minggu
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>Trimester</label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.trimester}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              trimester: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Jenis Kunjungan
                      </label>
                      <div className='input-group'>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.visit_types}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              visit_type: e.value,
                              visit_types: e,
                            })
                          }
                          options={[
                            {
                              value: "k1",
                              label: "K1",
                            },
                            {
                              value: "k2",
                              label: "K2",
                            },
                            {
                              value: "k3",
                              label: "K3",
                            },
                            {
                              value: "k4",
                              label: "K4",
                            },
                            {
                              value: "k5",
                              label: "K5",
                            },
                            {
                              value: "k6",
                              label: "K6",
                            },
                            {
                              value: "lainnya",
                              label: "Lainnya",
                            },
                          ]}
                        />
                        <div className='input-group-append'>
                          <button
                            onClick={() => setParam({
                              ...param,
                              visit_type: null,
                              visit_types: null,
                            })}
                            className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Text WA Pemeriksaan Selanjutnya
                      </label>
                      <textarea
                          className='form-control'
                          onChange={(e) =>
                              setWaText(e.target.value)
                          }
                          value={waText}
                          rows='5'
                      />
                    </div>
                  </div>
                  <div className='col-12 mb-2'>
                    <label className='form-control-label'>
                      Preview Text WA
                    </label>
                    <br/>
                    <i style={{fontSize: 14}}>{preview}</i>
                  </div>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label className='form-control-label'>Keluhan</label>
                      <div className='input-group'>
                        <input
                          type='text'
                          value={param.complaint}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              complaint: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Jumlah Janin
                      </label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.fetal_count}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fetal_count: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Tinggi Fundus
                      </label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.fundus_height}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fundus_height: e.target.value,
                              tbj: param.head_presentation ? (param.fundus_height - param.head_presentation) * 155 : 0
                            })
                          }
                          className='form-control'
                        />
                        <div className='input-group-append'>
                          <span className='input-group-text bg-secondary'>
                            cm
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Leopold 1
                      </label>
                      <div className='input-group'>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.fundus_height_explanations}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fundus_height_explanation: e.value,
                              fundus_height_explanations: e,
                            })
                          }
                          options={[
                            {
                              value: "Belum teraba",
                              label: "Belum teraba",
                            },
                            {
                              value: "3 jari diatas sym",
                              label: "3 Jari di Atas Sym",
                            },
                            {
                              value: "pertengahan sym-pst",
                              label: "Pertengahan Sym-Pst",
                            },
                            {
                              value: "3 jari dibawah pusat",
                              label: "3 Jari di Bawah Pusat",
                            },
                            {
                              value: "1 jari dibawah pusat",
                              label: "1 Jari di Bawah Pusat",
                            },
                            {
                              value: "sepusat",
                              label: "Setinggi pusat",
                            },
                            {
                              value: "3 jari diatas pusat",
                              label: "3 Jari di Atas Pusat",
                            },
                            {
                              value: "Pertengahan pusat px",
                              label: "Pertengahan pusat px",
                            },
                            {
                              value: "3 jari bawah px",
                              label: "3 jari bawah px",
                            },
                            {
                              value: "Setinggi px",
                              label: "Setinggi px",
                            },
                          ]}
                        />
                        <div className='input-group-append'>
                          <button
                            onClick={() => setParam({
                              ...param,
                              fundus_height_explanation: null,
                              fundus_height_explanations: null,
                            })}
                            className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Leopold 2
                      </label>
                      <div className='input-group'>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.leopold2s}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              leopold2: e.value,
                              leopold2s: e,
                            })
                          }
                          options={[
                            {
                              value: 1,
                              label: "Punggung kanan",
                            },
                            {
                              value: 1,
                              label: "Punggung kiri",
                            },
                            {
                              value: 2,
                              label: "Belum bisa dinilai",
                            },
                          ]}
                        />
                        <div className='input-group-append'>
                          <button
                            onClick={() => setParam({
                              ...param,
                              leopold2: 0,
                              leopold2s: null,
                            })}
                            className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>Leopold 3</label>
                      <div className='input-group'>
                        <Select2
                            className='form-control p-0 pt-1'
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                backgroundColor: "white",
                                border: "none",
                              }),
                            }}
                            value={param.fetal_positions}
                            onChange={(e) =>
                                setParam({
                                  ...param,
                                  fetal_position: e.value,
                                  fetal_positions: e,
                                })
                            }
                            options={[
                              {
                                value: "Kepala",
                                label: "Kepala",
                              },
                              {
                                value: "Bokong",
                                label: "Bokong",
                              },
                              {
                                value: "Melintang",
                                label: "Melintang",
                              },
                              {
                                value: "Obliq",
                                label: "Obliq",
                              },
                              {
                                value: "Balotemen",
                                label: "Balotemen",
                              },
                              {
                                value: "Belum bisa dinilai",
                                label: "Belum bisa dinilai",
                              },
                            ]}
                        />
                        <div className='input-group-append'>
                          <button
                              onClick={() => setParam({
                                ...param,
                                fetal_position: null,
                                fetal_positions: null,
                              })}
                              className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*param.fetal_position === 'memanjang'*/ 1 === 1 ? (
                    <>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Leopold 4</label>
                          <div className='input-group'>
                            <Select2
                              className='form-control p-0 pt-1'
                              styles={{
                                control: (styles) => ({
                                  ...styles,
                                  backgroundColor: "white",
                                  border: "none",
                                }),
                              }}
                              value={param.head_presentations}
                              onChange={(e) =>
                                setParam({
                                  ...param,
                                  head_presentation: e.value,
                                  head_presentations: e,
                                  tbj: param.head_presentation ? (param.fundus_height - param.head_presentation) * 155 : 0
                                })
                              }
                              options={[
                                {
                                  value: 11,
                                  label: "Konvergen (belum masuk panggul)",
                                },
                                {
                                  value: 12,
                                  label: "Divergen (sudah masuk panggul)",
                                },
                                {
                                  value: 13,
                                  label: "Belum bisa dinilai",
                                },
                              ]}
                            />
                            <div className='input-group-append'>
                              <button
                                onClick={() => setParam({
                                  ...param,
                                  head_presentation: null,
                                  head_presentations: null,
                                })}
                                className='btn btn-sm btn-danger'>
                                <span className='btn-inner--icon'>
                                  <i className='ni ni-fat-remove'></i>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Taksiran Berat Janin
                          </label>
                          <div className='input-group'>
                            <input
                              type='number'
                              value={param.fetal_position ? (param.fundus_height - param.head_presentation) * 155 : 0}
                              className='form-control'
                              readOnly={true}
                            />
                            <div className='input-group-append'>
                              <span className='input-group-text bg-secondary'>
                                gram
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : ''}
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Denyut Jantung Janin
                      </label>
                      <div className='input-group'>
                        <div className='form-control'>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinet1'
                              name='customRadioInlinet1'
                              className='custom-control-input'
                              checked={param.fetal_heart_beat ? "checked" : ""}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  fetal_heart_beat: true,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinet1'
                              className='custom-control-label'>
                              Ada
                            </label>
                          </div>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinet2'
                              name='customRadioInlinet1'
                              className='custom-control-input'
                              checked={param.fetal_heart_beat ? "" : "checked"}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  fetal_heart_beat: false,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinet2'
                              className='custom-control-label'>
                              Tidak Ada
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Jumlah Denyut Jantung
                      </label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.fetal_pulse}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fetal_pulse: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                        <div className='input-group-append'>
                          <span className='input-group-text bg-secondary'>
                            x/Menit
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>Edema</label>
                      <div className='form-control'>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInlinedema1'
                            name='customRadioInlinedema1'
                            className='custom-control-input'
                            checked={param.edema ? "checked" : ""}
                            onChange={(e) => {
                              setParam({
                                ...param,
                                edema: true,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInlinedema1'
                            className='custom-control-label'>
                            Ya
                          </label>
                        </div>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInlinedema2'
                            name='customRadioInlinedema2'
                            className='custom-control-input'
                            checked={param.edema ? "" : "checked"}
                            onChange={(e) => {
                              setParam({
                                ...param,
                                edema: false,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInlinedema2'
                            className='custom-control-label'>
                            Tidak
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>Refleks Patella</label>
                      <div className='form-control'>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInlinpatella1'
                            name='customRadioInlinpatella1'
                            className='custom-control-input'
                            checked={param.patella ? "checked" : ""}
                            onChange={() => {
                              setParam({
                                ...param,
                                patella: true,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInlinpatella1'
                            className='custom-control-label'>
                            Positif
                          </label>
                        </div>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInlinpatella2'
                            name='customRadioInlinpatella2'
                            className='custom-control-input'
                            checked={param.patella ? "" : "checked"}
                            onChange={() => {
                              setParam({
                                ...param,
                                patella: false,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInlinpatella2'
                            className='custom-control-label'>
                            Negatif
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='list-group-item mt-0 mb-0 text-white bg-gray'>
                <div className='h4 text-white'>TERAPI / IMUNISASI</div>
              </div>
              <div className='list-group-item mt-0 mb-0'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Diberikan Imunisasi TT
                      </label>
                      <div className='input-group'>
                        <div className='form-control'>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinett1'
                              name='customRadioInlinett1'
                              className='custom-control-input'
                              checked={param.tt_yes_no ? "checked" : ""}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  tt_yes_no: true,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinett1'
                              className='custom-control-label'>
                              Ya
                            </label>
                          </div>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinett2'
                              name='customRadioInlinett1'
                              className='custom-control-input'
                              checked={param.tt_yes_no ? "" : "checked"}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  tt_yes_no: false,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinett2'
                              className='custom-control-label'>
                              Tidak
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Imunisasi TT ke
                      </label>
                      <div className='input-group'>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.tt_immunizations}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              tt_immunization: e.value,
                              tt_immunizations: e,
                            })
                          }
                          options={[
                            {
                              value: "TT1",
                              label: "TT1",
                            },
                            {
                              value: "TT2",
                              label: "TT2",
                            },
                            {
                              value: "TT3",
                              label: "TT3",
                            },
                            {
                              value: "TT4",
                              label: "TT4",
                            },
                            {
                              value: "TT5",
                              label: "TT5",
                            },
                          ]}
                        />
                        <div className='input-group-append'>
                          <button
                            onClick={() => setParam({
                              ...param,
                              tt_immunization: null,
                              tt_immunizations: null,
                            })}
                            className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>Diberikan FE</label>
                      <div className='input-group'>
                        <div className='form-control'>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinette1'
                              name='customRadioInlinette1'
                              className='custom-control-input'
                              checked={param.fe_yes_no ? "checked" : ""}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  fe_yes_no: true,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinette1'
                              className='custom-control-label'>
                              Ya
                            </label>
                          </div>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinette2'
                              name='customRadioInlinette1'
                              className='custom-control-input'
                              checked={param.fe_yes_no ? "" : "checked"}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  fe_yes_no: false,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinette2'
                              className='custom-control-label'>
                              Tidak
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>FE ke</label>
                      <div className='input-group'>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.fes}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fe: e.value,
                              fes: e,
                            })
                          }
                          options={[
                            {
                              value: "fe 1",
                              label: "Fe 1",
                            },
                            {
                              value: "fe 2",
                              label: "Fe 2",
                            },
                            {
                              value: "fe 3",
                              label: "Fe 3",
                            },
                          ]}
                        />
                        <div className='input-group-append'>
                          <button
                            onClick={() => setParam({
                              ...param,
                              fe: null,
                              fes: null,
                            })}
                            className='btn btn-sm btn-danger'>
                            <span className='btn-inner--icon'>
                              <i className='ni ni-fat-remove'></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Jumlah Pemberian FE
                      </label>
                      <div className='input-group'>
                        <input
                          type='number'
                          value={param.fe_count}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              fe_count: e.target.value,
                            })
                          }
                          className='form-control'
                        />
                        <div className='input-group-append'>
                          <span className='input-group-text bg-secondary'>
                            tablet
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Pemberian Minyak Ber-Iodium
                      </label>
                      <div className='input-group'>
                        <div className='form-control'>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinettwe1'
                              name='customRadioInlinettwe1'
                              className='custom-control-input'
                              checked={param.iodized_oil ? "checked" : ""}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  iodized_oil: true,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinettwe1'
                              className='custom-control-label'>
                              Ya
                            </label>
                          </div>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInlinettwe2'
                              name='customRadioInlinettwe1'
                              className='custom-control-input'
                              checked={param.iodized_oil ? "" : "checked"}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  iodized_oil: false,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInlinettwe2'
                              className='custom-control-label'>
                              Tidak
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='list-group-item mt-0 mb-0 text-white bg-gray'>
                <div className='h4 text-white'>FAKTOR RISIKO & KOMPLIKASI</div>
              </div>
              <div className='list-group-item'>
                <div className='row'>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Faktor Risiko
                      </label>
                      <textarea
                        className='form-control'
                        onChange={(e) =>
                          setParam({ ...param, risk_factor: e.target.value })
                        }
                        value={param.risk_factor}
                        rows='3'
                      />
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label className='form-control-label'>Komplikasi</label>
                      <textarea
                        className='form-control'
                        onChange={(e) =>
                          setParam({ ...param, complication: e.target.value })
                        }
                        value={param.complication}
                        rows='3'
                      />
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='form-group'>
                      <label className='form-control-label'>
                        Ditemukan oleh
                      </label>
                      <div className='form-control'>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInline1'
                            name='customRadioInline1'
                            className='custom-control-input'
                            value='nakes'
                            checked={
                              param.found_by === "nakes" ? "checked" : ""
                            }
                            onChange={(e) => {
                              setParam({
                                ...param,
                                found_by: e.target.value,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInline1'
                            className='custom-control-label'>
                            Tenaga Kesehatan
                          </label>
                        </div>
                        <div className='custom-control custom-radio custom-control-inline'>
                          <input
                            type='radio'
                            id='customRadioInline2'
                            name='customRadioInline1'
                            className='custom-control-input'
                            value='masyarakat'
                            checked={
                              param.found_by === "masyarakat" ? "checked" : ""
                            }
                            onChange={(e) => {
                              setParam({
                                ...param,
                                found_by: e.target.value,
                              });
                            }}
                          />
                          <label
                            htmlFor='customRadioInline2'
                            className='custom-control-label'>
                            Masyarakat
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='btn btn-success' onClick={() => postParam()}>
            Simpan Pemeriksaan Kehamilan
          </div>
          <div className='btn btn-outline-default' onClick={() => setModalShow(false)}>
            Tutup
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default History;
